import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { Alert } from "@mui/material";
import axios from "../api/axios";

export default function AgreementFormDialog(props) {
  const [step, setStep] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const [useAlternateSigner, setUseAlternateSigner] = useState(false);
  const [title, setTitle] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [userAndOrgData, setUserAndOrgData] = useState(null);
  const [disabled,setDisabled] = useState(false);
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        if (errorMessage) {
          setErrorMessage("");
        }
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const fetchUserAndOrgData = async () => {
    axios.get('/api/get-userandorg-details').then((res) => {
      if (res.data?.success) {
        setUserAndOrgData(res.data.userData);
        setStep(true);
      } else {
        if (res.data.message) {
          setErrorMessage(res.data.message);
        } else {
          setErrorMessage("Faied to fetch user organisation data.");
        }
      }
      setDisabled(false);
    }).catch((res) => {
      setErrorMessage("Falied to fetch user organisation data.");
      setDisabled(false);
    })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);
    const errors = [];
    if (!acknowledged) {
      errors.push(
        "You must acknowledge that you have read and understood the agreement.",
      );
    }

    if (!useAlternateSigner && title.trim() === "") {
      errors.push("Title is required.");
    }
    if (title.trim().length > 30) {
      errors.push("Title cannnot exceed 30 characters.")
    }
    if (useAlternateSigner) {
      const nameRegex = /^[A-Za-z\s'-]+$/;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

      if (firstName.trim() === "") {
        errors.push("First name is required.");
      } else if (!nameRegex.test(firstName.trim())) {
        errors.push("First name contains invalid characters.");
      } else if (firstName.trim().length > 30) {
        errors.push("First name cannot exceed 30 characters.")
      }

      if (lastName.trim() === "") {
        errors.push("Last name is required.");
      } else if (!nameRegex.test(lastName.trim())) {
        errors.push("Last name contains invalid characters.");
      } else if (lastName.trim().length > 30) {
        errors.push("Last name cannnot exceed 30 characters.")
      }

      if (email.trim() === "") {
        errors.push("Email is required.");
      } else if (!emailRegex.test(email)) {
        errors.push("Enter a valid email address.");
      }
    }

    if (errors.length > 0) {
      setErrorMessage(errors.join("\n"));
      setDisabled(false);
      return;
    }
    setErrorMessage("");
    fetchUserAndOrgData();
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setUseAlternateSigner(checked);
    if (checked) {
      setTitle("");
    } else {
      setFirstName("");
      setLastName("");
      setEmail("");
    }
  };

  const confirmFocusedAgreementDetails = async () => {
    const data = {
      title : title,
      emailCheck: 0,
    };
    await props.agreementGeneration(data);
  };

  const confirmEmailAgreementDetails = async () => {
    const data = {
      signerfname: firstName,
      signerlname: lastName,
      signeremail: email,
      emailCheck: 1,
    };
    await props.agreementGeneration(data);
  };

  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onClose}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
        contentClassName="agreement-modal-content"
      >
        <Modal.Header closeButton>
          <Modal.Title>Token Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="p-3"
          style={{ height: "calc( 100vh - 200px)", overflowY: "scroll" }}
        >
          <div
            dangerouslySetInnerHTML={{ __html: props.agreementText }}
            className="text-center mb-4 p-3"
          ></div>
          <hr />
          {!step ? (
            <Form className="px-5">
              {errorMessage && (
                <Alert
                  severity="error"
                  onClose={() => setErrorMessage("")}
                  sx={{ mb: 2 }}
                >
                  {errorMessage.split("\n").map((err, index) => (
                    <div key={index}>{err}</div>
                  ))}
                </Alert>
              )}
              <Form.Group controlId="acknowledgeCheckbox" className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="I acknowledge that I have read and understood the above."
                  checked={acknowledged}
                  onChange={(e) => setAcknowledged(e.target.checked)}
                  style={{ paddingLeft: "0" }}
                />
              </Form.Group>

              <Form.Group controlId="titleInput" className="mb-3">
                <Form.Label>Title:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  disabled={useAlternateSigner}
                  maxLength="30"
                />
              </Form.Group>

              <Form.Group controlId="alternateSignerCheckbox" className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Check if you want someone else from your organization to sign the agreement on your behalf"
                  onChange={handleCheckboxChange}
                />
              </Form.Group>

              <Form.Group controlId="firstNameInput" className="mb-3">
                <Form.Label>First Name:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  disabled={!useAlternateSigner}
                  maxLength="30"
                />
              </Form.Group>

              <Form.Group controlId="lastNameInput" className="mb-3">
                <Form.Label>Last Name:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  disabled={!useAlternateSigner}
                  maxLength="30"
                />
              </Form.Group>

              <Form.Group controlId="emailInput" className="mb-3">
                <Form.Label>Email:</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={!useAlternateSigner}
                  maxLength="100"
                />
              </Form.Group>
            </Form>
          ) : (
            <div className="p-3">
              <p>I acknowledge that I have read and understood the above.</p>
              <p>
                <span>Company: </span>
                <span>{userAndOrgData.orgname}</span>
                <br />
                <span>Address: </span>
                <span>
                  {userAndOrgData.address} {userAndOrgData.city} {userAndOrgData.state} {userAndOrgData.zip}{" "}
                  {userAndOrgData.country}
                </span>
                <br />
                {!useAlternateSigner ? (
                  <>
                    <span>Name: </span>
                    <span>
                      {userAndOrgData.fname} {userAndOrgData.lname}
                    </span>
                    <br />
                    <span>Title: </span>
                    <span>{title}</span>
                  </>
                ) : (
                  <>
                    <span>Signer First Name: </span>
                    <span>{firstName}</span>
                    <br />
                    <span>Signer Last Name: </span>
                    <span>{lastName}</span>
                    <br />
                    <span>Signer Email: </span>
                    <span>{email}</span>
                  </>
                )}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="flex-column border-top p-0">
          <div className="d-flex flex-column flex-md-row justify-content-between my-3">
            {!step ? (
              <>
                <button
                  className="learnmore-btn m-0 mb-3 mb-md-0 me-md-2"
                  disabled = {disabled}
                  onClick={props.handleDownload}
                >
                  Download
                </button>
                <button
                  className="learnmore-btn m-0 ms-md-2"
                  disabled = {disabled}
                  onClick={handleSubmit}
                >
                  Proceed To Sign
                </button>
              </>
            ) : (
              <>
                <button
                  className="learnmore-btn m-0 mb-3 mb-md-0 me-md-2"
                  disabled={!useAlternateSigner}
                  onClick={() => {
                    confirmEmailAgreementDetails();
                    props.onClose();
                  }}
                >
                  Send Email To Signer
                </button>
                <button
                  className="learnmore-btn m-0 mb-3 mb-md-0 mx-md-2"
                  disabled={useAlternateSigner}
                  onClick={() => {
                    confirmFocusedAgreementDetails();
                    props.onClose();
                  }}
                >
                  Sign Here
                </button>
                <button
                  className="danger-btn m-0 ms-md-2"
                  onClick={props.onClose}
                >
                  Cancel
                </button>
              </>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
